import React from 'react'
import FeedbackHub from '../../../components/performance/FeedbackHub'

export default function FeedbacksPage() {
  return (
    
            <FeedbackHub />
          
  )
}
